import React, { useCallback, useContext } from "react";
import { withRouter, Redirect } from "react-router";
import {app} from "./firebaseconfig";
import Header1 from "./Header"
import Footer from "./Footer"
import { Button, Form, FormGroup, Label, Input, FormText, Alert } from 'reactstrap';
import ReactGA from "react-ga"


//import { AuthContext } from "./Auth.js";

const Login = ({ history }) => {
  const handleLogin = useCallback(
    async event => {
      event.preventDefault();
      const { email, password } = event.target.elements;
      try {
        await app
          .auth()
          .signInWithEmailAndPassword(email.value, password.value);
          history.push("/Upload_Your_Documents");
      } catch (error) {
        alert(error);
      }
    },
    [history]
  );

  
  //const { currentUser } = useContext(AuthContext);

  //if (app.auth().currentUser) {
   // return <Redirect to="/" />;
 // }

  return (
    <>
    <section id="cta2" className="container">
    <Header1></Header1>
    </section>
    <br></br>
    <br></br>
    <br></br>
    <section className="box special">
     <form onSubmit={handleLogin}>
     
     <h2>Sign in</h2><br/>
    
      <Input type="email" name="email" placeholder="Email" /><br/>

      <Input type="password" name="password" placeholder="Password" /><br/>
       <br></br>
       
   

              
        
    <button type="submit" className="button primary"> Sign in </button> 
    
    
      <br></br><br></br>
    <a href="/signup">Dont Have an Account? Sign Up Now</a><br></br><br/>
    <a href="/ForgotPassword">Forgot Password</a>
   
   </form>
   </section>
   <Footer></Footer>
   </>
  );
};

export default withRouter(Login);